module.exports = __webpack_public_path__ + "static/media/unsw_neg.18a1f42b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/unsw_neg.png
// module id = 1388
// module chunks = 0